import { SliceCaseReducers, createSlice } from '@reduxjs/toolkit';

export interface InvoiceDetailsInterface {
    nameOfOrganization: string,
    invoiceEmail: string,
    taxNumber: string,
    street: string,
    houseNumber: string,
    postcode: string,
    city: string,
    country: "Belgium" | "Netherlands" | "France",
    orderForm: boolean,
    haveOrderFormNumber: "Yes" | "No",
    orderFormNumber: string,
    comments: string
}

export const invoiceSlice = createSlice<InvoiceDetailsInterface, SliceCaseReducers<InvoiceDetailsInterface>>({
    name: 'customerDetails',
    initialState: {
        nameOfOrganization: "",
        invoiceEmail: "",
        taxNumber: "",
        street: "",
        houseNumber: "",
        postcode: "",
        city: "",
        country: "Belgium",
        orderForm: false,
        haveOrderFormNumber: "No",
        orderFormNumber: "",
        comments: ""
    },
    reducers: {
        /**
         * Input object with attributes to overwrite
         */
        changeInvoiceDetails: (state, action) => {
            const partialObj = action.payload;
            const newState = {
                ...state,
                ...partialObj
            }
            return newState;
        }
    }
});

export const { changeInvoiceDetails, checkValidity: checkInvoiceValidity } = invoiceSlice.actions;
export default invoiceSlice.reducer;